// material-ui
import {
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { getUserClaims } from 'features/application/application-slice'
import * as autoThunks from 'features/auto-thunks'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TitleService from 'title-service'

import { get_all_contentCreatorInvite } from 'features/contentCreatorInvite/contentCreatorInvite-slice'
// project imports
import AnimateButton from 'ui-component/extended/AnimateButton'

// styles
const CardStyle = styled(Card)(({ theme }) => ({
  background:
    theme.palette.mode === 'dark'
      ? theme.palette.dark[800]
      : theme.palette.warning.light,
  marginTop: '16px',
  marginBottom: '16px',
  overflow: 'hidden',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    width: '200px',
    height: '200px',
    border: '19px solid ',
    borderColor:
      theme.palette.mode === 'dark'
        ? theme.palette.warning.main
        : theme.palette.warning.main,
    borderRadius: '50%',
    top: '65px',
    right: '-150px',
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    width: '200px',
    height: '200px',
    border: '3px solid ',
    borderColor:
      theme.palette.mode === 'dark'
        ? theme.palette.warning.main
        : theme.palette.warning.main,
    borderRadius: '50%',
    top: '145px',
    right: '-70px',
  },
}))

// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

const HeaderCard = () => {
  const theme = useTheme()
  const _list = useSelector(get_all_contentCreatorInvite)
  const claims = useSelector(getUserClaims)
  const dispatch = useDispatch()
  const [shouldShow, setShouldShow] = useState(false)

  useEffect(() => {
    function get_player_invites(): boolean {
      return (
        _list.filter(
          (x) => !x.deleted && claims?.email === x.contentCreatorEmail,
        ).length > 0
      )
    }
    let shouldShow = get_player_invites()
    setShouldShow(shouldShow)
  })
  useEffect(() => {
    if (claims?.email) {
      dispatch(autoThunks.get_content_creator_invite({ email: claims?.email }))
    }
  }, [claims?.email])
  if (!shouldShow) {
    return <></>
  }
  return (
    <CardStyle>
      <CardContent>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h4">
              {TitleService('Content Creator Invite')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="subtitle2"
              color={
                theme.palette.mode === 'dark' ? 'textSecondary' : 'grey.900'
              }
              sx={{ opacity: theme.palette.mode === 'dark' ? 1 : 0.6 }}
            >
              {TitleService('Accept to become a content creator')}
            </Typography>
          </Grid>
          <Grid item>
            <Stack direction="row">
              <AnimateButton>
                <Button
                  variant="contained"
                  onClick={async () => {
                    await dispatch(
                      autoThunks.accept_content_creator_invite({
                        email: claims?.email,
                        user: claims?.fire_user,
                      }),
                    )
                  }}
                  color="warning"
                  sx={{ boxShadow: 'none' }}
                >
                  {TitleService('Join')}
                </Button>
              </AnimateButton>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </CardStyle>
  )
}

export default HeaderCard
